import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { IntegrityMonitorPauseController } from '../controller/IntegrityMonitorPauseController';
import { BaseFormFieldWebComponentElement } from '../../../framework/BaseFormFieldWebComponentElement';
import { IntegrityMonitorPauseSchema } from '../type';

export class IntegrityMonitorPauseWebComponent extends BaseFormFieldWebComponentElement<IntegrityMonitorPauseSchema> {
  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: IntegrityMonitorPauseController,
    });
  }
}
